// @ts-ignore
import RobotoRegular from '../../assets/fonts/Roboto-Regular.ttf';
// @ts-ignore
import RobotoMedium from '../../assets/fonts/Roboto-Medium.ttf';
// @ts-ignore
import RobotoBold from '../../assets/fonts/Roboto-Bold.ttf';

const sfPro = {
  fontFamily: 'RobotoRegular',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(${RobotoRegular})
  `
};
const sfProMedium = {
  fontFamily: 'RobotoMedium',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(${RobotoMedium})
  `
};
const sfProBold = {
  fontFamily: 'RobotoBold',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(${RobotoBold})
  `
};

export default {
  '@global': {
    '@font-face': [sfPro, sfProMedium, sfProBold]
  }
};
